<template>
  <transition name="fade">
    <div v-if="visible" class="popup-overlay">
      <div class="popup">
        <img src="../../assets/img/ic_check.png" alt="icon" class="popup__icon" />
        <div class="popup__message">{{ message }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SuccessPopup",
  props: {
    message: {
      type: String,
      default: "Зміни збережено!",
    },
    duration: {
      type: Number,
      default: 3000,
    },
    icon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, this.duration);
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.1);
}

.popup {
  background: white;
  padding: 40px 50px;
  border-radius: 12px;
  border: 1px solid #EFF4FE;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 300px;
}

.popup__icon {
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
}

.popup__message {
  font-size: 14px;
  font-weight: 700;
  color: #5E6277;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
